import { DropZoneWrapper } from "../Common/DropZoneWrapper";

export default {
    init() {
        this.getImagesModal();
        this.uploadImage();
        this.copyImageUrl();
        this.removeImage();
        this.previewCleaner();
        if (window.location.pathname == '/admin/shared-file') {
            this.dropzoneListners();
        }
    },
    getImagesModal() {
        let directory = $('#images #directory').text();
        $('body').on('click', '#images', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/admin/uploads/images',
                data: ({
                    directory: directory,
                }),
                success: function (response) {
                    $('#modal_images').html(response);
                    $('#images_modal').modal('show');
                },
            });
        });
    },
    getImages() {
        let directory = /* $('#images #directory').text() ?? */ 'shared-file';
        $.ajax({
            type: 'GET',
            url: '/admin/uploads/images',
            data: ({
                list: '_list',
                directory: directory,
            }),
            success: function (response) {
                $('#images-modal-content').html(response);
            },
        });
    },
    uploadImage() {
        let $this = this;
        let directory = $('#images #directory').text();
        $('body').on('click', '#upload_image', function(e) {
            e.preventDefault();
            let form = $(this).closest('form')[0];
            let data = new FormData(form);
            data.append('directory', directory);
            $.ajax({
                type: 'POST',
                url: '/admin/uploads/upload-image',
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: function (response) {
                    $this.getImages();
                    $('#error_upload_image').removeClass(['d-none', 'alert-danger']);
                    $('#error_upload_image').find('.mb-0').html(response);
                    $('#error_upload_image').addClass(['alert-success']);
                },
                error: function(response) {
                    let errors = response.responseJSON.errors;
                    $.each(errors, function (key) {
                        $('#error_' + key).find('.mb-0').html(errors[key]);
                        $('#error_' + key).removeClass(['d-none', 'alert-success']);
                        $('#error_' + key).addClass(['alert-danger']);
                    })
                }
            });

        });
    },
    removeImage() {
        let $this = this;
        $('body').on('click', '.remove_image', function(e) {
            e.preventDefault();
            let image = $(this).closest('tr').find('a').attr('href');
            image = image.replace(/https?:\/\/.*?\//, '');

            $.ajax({
                type: 'POST',
                url: '/admin/shared-file/remove-shared-file',
                data: ({
                    image: image,
                }),
                success: function (response) {
                    $this.getImages();
                },
            });
        });
    },
    copyImageUrl() {
        $('body').on('click', '.copy_image', function(e) {
            $('.copy_image').each(function(i, el){
                $(el).removeClass(['text-success', 'border', 'border-success']);
            });
            let el = $(this).closest('li').find('a');
            $(this).addClass(['text-success', 'border', 'border-success']);
            navigator.clipboard.writeText(el.text());
        });
    },
    previewCleaner() {
        $('body').on('keyup', '#article_publication .preview', function(e) {
            e.preventDefault();
            const regex = new RegExp('.*\/([^\\s]*).*')
            $(this).val($(this).val().replace(regex, '$1'));
        });
    },
    initDropzone(options={}, addQueryData={}){
        if (this.dropzone) delete this.dropzone;
        let local_options = {
            modal: {
                template: '#dropzone',
                selector: '#dropzone-modal',
                submit: {
                    element: '#submit-attachments',
                    event: 'click',
                    handler: (files, callback=()=>{}) => {
                        this.attachFiles(files, callback, addQueryData);
                    }
                },
                remove_file: {
                    element: '.delete-file-button',
                    event: 'click',
                    handler: (files) => {
                        console.log(files);
                    }
                }
            },
        };
        let complete_options = Object.assign(local_options, options);
        this.dropzone = DropZoneWrapper.init(complete_options, {
            url: '/admin/shared-file/upload-documents'
        });
    },
    dropzoneListners(){
        $('.admin_upload_files')
            .off('click')
            .on('click', (e) => {
                let ftype = $(e.currentTarget).attr('data-file_type')
                this.initDropzone({accessFileType:ftype}, {});
            });
    },
    async attachFiles(files, callback=() => {}, addQueryData={}) {
        const url = '/admin/shared-file/upload-documents';

        if (url == 'restrict') {
            callback();
            return;
        };

        let flag = true;
        $('.dropzone-error-message-container').text('');
        let file_type = "documents";
        let data = await this.prepareFilesData(files, file_type)
        for(let key in addQueryData){
            data.append(key,addQueryData[key])
        }
        $.ajax({
            url,
            method: "POST",
            processData: false,
            contentType: false,
            data,
            success: (response) => {
                callback(response);
                delete this.dropzone;
            },
            error: (response) => {
                let errors = {};
                if (response.status == 413) {
                    errors['filesize'] = ['File is too large. Size limit is 5mb.'];
                } else {
                    errors = response.responseJSON.errors;
                }

                if (errors) {
                    $('.dropzone-error-message-container').text('Error: ');
                    Object.values(errors)[0].forEach(element => {
                        $('.dropzone-error-message-container').append('<br>'+element);
                    });
                    $('.dropzone-error-message-container').removeClass('d-none');
                }
                flag = false;
            }
        });
        return flag;
    },

    async prepareFilesData(files, file_type=null) {
        let data = new FormData()
        for(let i=0; i<files.length; i++){
            if(files[i]?.upload?.filename && files[i].name != files[i].upload.filename)
                files[i] = new File([files[i]], files[i].upload.filename ,{type: files[i].type})
        }

        //files = await this.zipImages(files)
        for(let key in files){
            if (file_type !==null) {
                data.append(file_type, files[key]);
            }else{
                data.append('files[' + files[key].type + '][]', files[key]);
            }
        }
        return data;
    },

    async zipImages(files){
        try{
            const promisses = []
            const images = files.filter(f=>this.compressFormats.includes(f.type))
            if(!images.length)
                return files
            for(let image of images){
                promisses.push(this.compressImage(image))
            }
            let results = (await Promise.allSettled(promisses)).filter(r=>r!=false && r?.status=='fulfilled')
                                                                .map(r=>r.value)
            results = [...results, ...files.filter(f=>!this.compressFormats.includes(f.type))]
            return results
        }catch(err){
            console.log(err)
            return false
        }
    },

    compressImage(file) {
        return new Promise(resolve => {
            new Compressor(file, {
                convertTypes: ['image/png'],
                convertSize: 100000,
                quality: 0.6,
                maxWidth: this.maxScaleImagePx,
                maxHeight: this.maxScaleImagePx,
                success: (result) => {
                    resolve(new File([result], result.name, {type: result.type}));
                },
                err: (err)=>{
                    resolve(false)
                }
            });
        });
    },

}
